/* eslint-disable react/prefer-stateless-function,no-unused-vars */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import { t } from 'utils/translates';

import {
  sendRequest,
  selectRequestState,
  selectFieldNoticeSubscribe,
  selectEventsUserNoticeTypesCategory,
  changeFieldNoticeSubscribe,
  requestRecoveryForm
} from 'mt-react-common/modules/events/common/reducers/userNoticesSubscribeForm';

import OpacityPreLoader from '../../../../../components/Common/PreLoaders/OpacityPreLoader';
import MediumPreLoader from '../../../../../components/Common/PreLoaders/MediumPreLoader';

const userNoticesSubscribeFormRN =
  'eventsModule.forms.userNoticesSubscribeForm';

class CustomizeNotifications extends Component {
  constructor(props) {
    super(props);
    this.selectFieldNoticeSubscribeMap = _.keyBy(
      props.eventsUserNoticeTypesCategoryArr,
      'id'
    );
    props.requestRecoveryForm();
  }

  getCategoryTitleById = catId =>
    this.selectFieldNoticeSubscribeMap[catId].title;

  handleSubscribeToggle = (catId, type, isChecked) => {
    const subscribersList = this.props.selectFieldNoticeSubscribe.value;
    subscribersList.find(x => x.user_notice_types_category_id === catId)[
      type
    ] = isChecked ? '0' : '1';
    this.props.changeFieldNoticeSubscribe(subscribersList);
  };

  render() {
    if (this.props.selectFieldNoticeSubscribe.value.length > 0) {
      return (
        <div className="panel panel-default panel-heading_padding-large panel-footer_padding-large">
          <div className="panel-heading text-center">
            <h1 className="panel-title">
              <i className="fa fa-bell-slash" /> {t('Настройка уведомлений')}
            </h1>
          </div>
          <div className="pos-rel">
            {this.props.requestState.hasInProgress ? (
              <OpacityPreLoader />
            ) : null}
            <div className="table-responsive">
              <table className="table table-vertical-align-middle table-hover table-text-center m-b-0">
                <thead>
                  <tr>
                    <th className="text-left">{t('Событие')}</th>
                    <th>{t('Сообщение на сайте')}</th>
                    <th>{t('Уведомления на эл. почту')}</th>
                  </tr>
                </thead>
                <tbody>
                  {this.props.selectFieldNoticeSubscribe.value.map(item => (
                    <tr
                      key={`CustomizeNotificationsItem${item.user_notice_types_category_id}`}
                    >
                      <td className="text-left">
                        {this.getCategoryTitleById(
                          item.user_notice_types_category_id
                        )}
                      </td>
                      <td>
                        <div className="checkbox abc-checkbox abc-checkbox-primary">
                          <input
                            className="styled styled-primary ng-untouched ng-pristine ng-valid"
                            type="checkbox"
                            defaultChecked={item.app_notice.toString() === '1'}
                            id={`noticeApp${item.user_notice_types_category_id}`}
                            onClick={() =>
                              this.handleSubscribeToggle(
                                item.user_notice_types_category_id,
                                'app_notice',
                                item.app_notice.toString() === '1'
                              )
                            }
                          />
                          <label
                            htmlFor={`noticeApp${item.user_notice_types_category_id}`}
                          />
                        </div>
                      </td>
                      <td>
                        <div className="checkbox abc-checkbox abc-checkbox-primary">
                          <input
                            className="styled styled-primary ng-valid ng-dirty ng-touched"
                            type="checkbox"
                            defaultChecked={
                              item.email_notice.toString() === '1'
                            }
                            id={`noticeEmail${item.user_notice_types_category_id}`}
                            onClick={() =>
                              this.handleSubscribeToggle(
                                item.user_notice_types_category_id,
                                'email_notice',
                                item.email_notice.toString() === '1'
                              )
                            }
                          />
                          <label
                            htmlFor={`noticeEmail${item.user_notice_types_category_id}`}
                          />
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div className="panel-footer">
              <div className="btn-toolbar">
                <button
                  className="btn btn-primary"
                  data-target="#modalConfirmSaveAnketa"
                  data-toggle="modal"
                  type="button"
                  onClick={this.props.sendRequest}
                >
                  {t('Сохранить')}
                </button>
              </div>
            </div>
          </div>
        </div>
      );
    }
    return <MediumPreLoader />;
  }
}

CustomizeNotifications.propTypes = {
  // CONNECT
  requestState: PropTypes.shape({
    hasInProgress: PropTypes.bool.isRequired
  }).isRequired,
  selectFieldNoticeSubscribe: PropTypes.shape({
    value: PropTypes.arrayOf(PropTypes.shape()).isRequired
  }).isRequired,
  eventsUserNoticeTypesCategoryArr: PropTypes.arrayOf(PropTypes.shape)
    .isRequired,

  sendRequest: PropTypes.func.isRequired,
  requestRecoveryForm: PropTypes.func.isRequired,
  changeFieldNoticeSubscribe: PropTypes.func.isRequired
};

const mapStateToProps = (state, props) => ({
  eventsUserNoticeTypesCategoryArr: selectEventsUserNoticeTypesCategory(state),
  selectFieldNoticeSubscribe: selectFieldNoticeSubscribe(
    state,
    userNoticesSubscribeFormRN
  ),
  requestState: selectRequestState(state, userNoticesSubscribeFormRN)
});

const mapDispatchToProps = (dispatch, props) => ({
  sendRequest: () => dispatch(sendRequest(userNoticesSubscribeFormRN)),
  requestRecoveryForm: () =>
    dispatch(requestRecoveryForm(userNoticesSubscribeFormRN)),
  changeFieldNoticeSubscribe: value =>
    dispatch(changeFieldNoticeSubscribe(userNoticesSubscribeFormRN, value))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CustomizeNotifications);



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Content/Main/CustomizeNotifications/CustomizeNotifications.js